import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// this.$store.state.caseType; // 取值
// this.$store.commit('SET_CASE_TYPE', 1); // 设置值
// this.$store.dispatch('setCaseType', 1); // 设置值
export default new Vuex.Store({
	state: {
		caseList: [], // 案例类型
	},
	getters: {},
	mutations: {
		SET_CASE_LIST(state, type) {
			state.caseList = type;
		}
	},
	actions: {
		setCaseList({
			commit
		}, type) {
			commit('SET_CASE_LIST', type);
		}
	},
	modules: {}
});